import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, HeadlinePage, SearchBarBox } from 'components/common';
import { Paper } from '@mui/material';
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm } from 'react-hook-form';


const UserListDumb = ({
  handleCreate,
  handleDelete,
  handleEdit,
  handleSearch,
  searchValue,
  content,
  isLoaded,
}) => {

  const [t] = useTranslation();
  const methods = useForm();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onDelete = (user) => {
    handleDelete(user);
  };

  const onEdit = (user) => {
    handleEdit(user);
  };

  const columns = [
    { label: t('common.components.table.col.username'), key: 'username' },
    { label: t('common.components.table.col.name'), key: 'firstname' },
    { label: t('common.components.table.col.surname'), key: 'surname' },
  ];

  const actions = [
    {
      label: t('userList.components.table.edit'),
      icon: <EditOutlinedIcon color="primary" />,
      handle: onEdit,
    },
    {
      label: t('userList.components.table.delete'),
      icon: <HighlightOffIcon color="primary" />,
      handle: onDelete,
    },
  ];

  return (
    <>

      <HeadlinePage
        title="userList.headline"
        buttonLabel="userList.components.add"
        handleOnClick = { handleCreate }
      />

      <SearchBarBox
        onSubmit={ onSubmit }
        methods={ methods }
        hideProject={ true }
        searchValue={searchValue}
      />


      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="userList.components.titleList"
          columns={columns}
          content={content}
          actions={actions}
          loading={isLoaded}
          handleNotResults={handleCreate}
        />
      </Paper>
    </>
  )
}

export default UserListDumb;
